export default "__VITE_ASSET__BfJHIasM__"